import { UsuarioPopula } from '../usuario-popula';

export class UsuarioPopulaAgrupamentoPerfil {
    perfil: number;
    nomePerfil: string;
    usuarios: UsuarioPopula[];

    constructor(perfil: number, nomePerfil: string) {
        this.perfil = perfil;
        this.nomePerfil = nomePerfil;
        this.usuarios = [];
    }
}
